<template>
  <div>
    <pdl-steps v-model="currentStep" @change="navigate">
      <template v-for="step in steps">
        <pdl-steps-item
          v-if="hasGaTag && step.progressBarId === progressBarId"
          id="ga-tagging-checkout"
          :key="step.progressBarId"
          :qaid="`${step.progressBarId}-nav-link`"
          :data-step-number="step.stepNumber"
          :data-step-name="`trek.checkout.ga.${progressBarId}`"
          v-html="bp(step.progressBarId)"
        />
        <pdl-steps-item
          v-else
          :key="step.progressBarId"
          :qaid="`${step.progressBarId}-nav-link`"
          v-html="bp(step.progressBarId)"
        />
      </template>
    </pdl-steps>

    <slot name="google-analytics" />
  </div>
</template>

<script>
import {PdlSteps, PdlStepsItem} from '@pedal/pdl-steps';
import {mapState} from 'vuex';

export default {
  components: {PdlSteps, PdlStepsItem},

  props: {
    steps: {
      type: Array,
      default: () => [],
      required: true,
    },
    progressBarId: {
      type: String,
      default: '',
      required: true,
    },
    hasGaTag: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentStep: 0,
    };
  },

  computed: {
    ...mapState('backend', ['encodedContextPath']),
  },

  created() {
    this.currentStep = this.steps.indexOf(this.steps.find((item) => item.progressBarId === this.progressBarId));
  },

  methods: {
    navigate(stepIndex) {
      if (Array.isArray(this.steps) && this.steps.length > stepIndex) {
        window.location.href = `${this.encodedContextPath}${this.steps[stepIndex].url}`;
      }
    },
  },
};
</script>
